import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController, } from '@ionic/angular';
import { EventProvider } from '../../../../../../../providers/event/event';
import { activities, ITeam, LineUpService, TshirtStyle } from '../../../../../lineup/services/lineup-service';
import { TournamentService, IPlan, offlineUnloadKey$, PlanEnum } from '../../../../services/tournament.service';
import { SportAlgoUtils } from '../../../../services/sport.algo';
import { Router } from '@angular/router';

@Component({
  selector: 'plan-one',
  templateUrl: 'plan-one.html',
  styleUrls:['./plan-one.scss']
})
export class PlanOnePage {
  plan: IPlan = {
    id: new Date().getTime(),
    name: "",
    plantype: PlanEnum.PlanOnePage,
    eventId: 0,
    sporttype: 4,
    rounds: 1,
    teamNum: 2,
    days: 1,
    games: 1,
    teams: [],
    gameTable: []
  };

  events = [];

  constructor(
    private gs: TournamentService,
    private router:Router,
    private ls: LineUpService,
    private navCtrl: NavController,
    private loader: LoadingController,
    private eventService: EventProvider,
    private translate: TranslateService
  ) {
    this.getEvents();
  }

  getEvents() {
    this.eventService.getClientEvents().then(events => {
      this.events = events;
      if(events) this.plan.eventId = this.events[0].id;
    });
  }

  getSportName(){
    return this.translate.instant(activities[this.plan.sporttype].path);
  }

  ionViewDidEnter() {
    this.plan.name = "Spielplan " + (this.gs.planList.length + 1);
  }

  save() {
    this.createTeams().then(async(teams) => {
      this.plan.teams = teams;
      this.setMatches();
      let load = await this.loader.create({});
      load.present();
      this.gs.saveTou(this.plan).then(plan => {
        this.plan = plan;
        this.gs.planList.push(this.plan);
        this.gs.save();
        this.gs.$planListChangeSub.next(true);
        load.dismiss();
      }).catch(()=>{
        load.dismiss()
      });
      this.navigate();
    });
  }

  filter(plan: any) {
    let obj = JSON.parse(JSON.stringify(plan));
    delete obj.gameTable;
    delete obj.id;
    return obj;
  }

  navigate() {

    this.navCtrl.navigateRoot('/tab2').then(() => {
      console.log('done');
      // this.app.getRootNav().getActiveChildNav().select(2)
    });
  }

  createTeams() {
    return new Promise<any>((resolve, reject) => {
      let id = 0;
      for (let i = 0; i < this.plan.teamNum; i++) {
        let team: ITeam = {
          id: new Date().getTime() + id,
          name: 'Team ' + (i + 1),
          results: 0,
          points: 0,
          image: null,
          ord: id + 1,
          players: []
        };
        this.plan.teams.push(team);
        id += 1;
      }
      if(navigator.onLine){
        // console.log('a-1');
        this.gs.saveTeams(this.plan.teams).then(teams => resolve(teams)).catch(err => console.warn(JSON.stringify(err)));
        console.log('a-1');
      }else{
        localStorage.setItem(offlineUnloadKey$, "true");
        resolve(this.plan.teams);
      }
    });
  }

  onAddEvent() {

  }

  setMatches() {
    for (let r = 0; r < this.plan.rounds; r++) {
      let table = SportAlgoUtils.createGamePlan(this.plan.teams, Number(this.plan.teamNum), this.plan, r);
      this.plan.gameTable.push(table);
    }
  }

  onTeamNumChange() {
    this.plan.days = this.plan.teamNum - 1;
    this.plan.games = SportAlgoUtils.calcGames(this.plan.teamNum, 0);
  }

  convert(n: number, returnValue: number) {
    return n % returnValue ? n % returnValue : returnValue;
  }
}




